"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_CONSTANTS = exports.SUGGESTIONS_MIN_QUERY_FETCH_LENGTH = exports.COUTRY_CODE = exports.CHINA_LOCALE = exports.CHINA_HOST = void 0;
var COUTRY_CODE = {
  CHINA: 'CN'
};
exports.COUTRY_CODE = COUTRY_CODE;
var CHINA_HOST = 'airasia.cn';
exports.CHINA_HOST = CHINA_HOST;
var CHINA_LOCALE = 'zh-cn';
exports.CHINA_LOCALE = CHINA_LOCALE;
var SUGGESTIONS_MIN_QUERY_FETCH_LENGTH = {
  'zh-cn': 1,
  'zh-hk': 1,
  'zh-tw': 1,
  'ja-jp': 1,
  'vi-vn': 3,
  'ko-kr': 1,
  'th-th': 3,
  'en-gb': 3,
  'id-id': 3,
  'ms-my': 3
};
exports.SUGGESTIONS_MIN_QUERY_FETCH_LENGTH = SUGGESTIONS_MIN_QUERY_FETCH_LENGTH;
var TRACKING_CONSTANTS = {
  actions: {
    click: 'click',
    tap: 'tap',
    search: 'aa_htl_search',
    view: 'view'
  },
  category: 'Hotels SA|hotelsearchwidget',
  lineofbusiness: 'Hotels SA',
  screenName: 'Home'
};
exports.TRACKING_CONSTANTS = TRACKING_CONSTANTS;